import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ZXingScannerModule } from '@zxing/ngx-scanner';

import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';

import { MenuComponent } from './shared/menu/menu.component';

import { LoginComponent } from './pages/login/login/login.component';
import { DialogElementsExampleDialog } from './pages/login/login/login.component';
import { DialogCameraCounter } from './pages/time/scan/scan.component';
import { DialogCameraCounterParticipant } from './pages/participant/participantscan/participantscan.component';
import { ParticipantkeyboardComponent } from './pages/participant/participantkeyboard/participantkeyboard.component';
import { ParticipantscanComponent } from './pages/participant/participantscan/participantscan.component';
import { ParticipanteditComponent } from './pages/participant/participantedit/participantedit/participantedit.component';
import { MenutitleComponent } from './shared/menutitle/menutitle.component';
import { MatSpinnerOverlayComponent } from './shared/mat-spinner-overlay/mat-spinner-overlay.component';
import { ParticipantdetailsComponent } from './pages/participant/participantedit/participantdetails/participantdetails.component';

import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { NgxVibrationModule } from 'ngx-vibration';

import { MassStartComponent } from './pages/mass-start/mass-start/mass-start.component';
import { MassStartDoneComponent } from './pages/mass-start/mass-start-done/mass-start-done.component';
import { ScanComponent } from './pages/time/scan/scan.component';
import { TypeComponent } from './pages/time/type/type.component';

import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatBadgeModule} from '@angular/material/badge';
import {MatGridListModule} from '@angular/material/grid-list';

import {ConnectionServiceModule} from 'ng-connection-service';
import { SyncComponent } from './shared/sync/sync.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';  

// https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
const dbConfig: DBConfig = {
  name: 'MyDb',
  version: 6,
  objectStoresMeta: [
    {
      store: 'timingmobi',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'json', keypath: 'json', options: { unique: false } },
      ],
    },
  ],
};

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    LoginComponent,
    ParticipantkeyboardComponent,
    ParticipantscanComponent,
    ParticipanteditComponent,
    MenutitleComponent,
    MatSpinnerOverlayComponent,
    DialogElementsExampleDialog,
    DialogCameraCounter,
    DialogCameraCounterParticipant, 
    ParticipantdetailsComponent,
    MassStartComponent,
    MassStartDoneComponent,
    ScanComponent,
    TypeComponent,
    SyncComponent,
  ],
  imports: [
    BrowserModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDialogModule,
    MatDividerModule,
    ZXingScannerModule, 
    MatSnackBarModule, 
    MatBadgeModule, 
    MatGridListModule, 
    NgxVibrationModule,  
    ConnectionServiceModule, ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
